import { render } from "./ManageDataAudit.vue?vue&type=template&id=00858b9f&scoped=true"
import script from "./ManageDataAudit.vue?vue&type=script&lang=js"
export * from "./ManageDataAudit.vue?vue&type=script&lang=js"

import "./ManageDataAudit.vue?vue&type=style&index=0&id=00858b9f&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00858b9f"]])

export default __exports__